"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var CloseX = function CloseX() {
  return _react.default.createElement("svg", {
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, _react.default.createElement("title", null, "Close"), _react.default.createElement("g", {
    id: "\uD83D\uDE80-Components",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", {
    id: "drawer_component",
    transform: "translate(-418.000000, -126.000000)",
    fill: "#B5BACE",
    fillRule: "nonzero"
  }, _react.default.createElement("g", {
    id: "Group-7",
    transform: "translate(78.000000, 97.000000)"
  }, _react.default.createElement("g", {
    id: "Group",
    transform: "translate(30.000000, 20.000000)"
  }, _react.default.createElement("polygon", {
    id: "Close-X",
    points: "324 10.41 322.59 9 317 14.59 311.41 9 310 10.41 315.59 16 310 21.59 311.41 23 317 17.41 322.59 23 324 21.59 318.41 16"
  }))))));
};

var _default = CloseX;
exports.default = _default;